import { Component, inject, OnInit, signal } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import {
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonHeader,
  IonInput,
  IonMenuButton,
  IonRow,
  IonTitle,
  IonToolbar,
  ToastController,
  IonNav,
  IonSpinner,
} from '@ionic/angular/standalone';

import { AuthService } from '../../providers/auth.service';
import { ForgotPasswordPage } from '../forgot-password/forgot-password';

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
  styleUrls: ['./login.scss'],
  imports: [
    FormsModule,
    IonButton,
    IonButtons,
    IonCol,
    IonContent,
    IonHeader,
    IonInput,
    IonMenuButton,
    IonRow,
    IonTitle,
    IonToolbar,
    IonSpinner,
  ],
})
export class LoginPage implements OnInit {
  private nav = inject(IonNav);
  private authService = inject(AuthService);
  private toastCtrl = inject(ToastController);

  login: { email: string; password: string } = { email: '', password: '' };

  isSubmitting = signal(false);

  async ngOnInit() {
  }

  onLogin(form: NgForm) {
    if (form.valid && !this.isSubmitting()) {
      this.isSubmitting.set(true);

      this.authService.login(this.login.email, this.login.password)
        .pipe(
          finalize(() => {
            this.isSubmitting.set(false);
          })
        )
        .subscribe({
          next: async (res: any) => {
            if (res) {
              //await this.authService.navigateToStartRoute();
            }
          },
          error: (error: any) => {
            let errorMessage = 'Greška prilikom prijave!';
            if (error?.status === 401 || error?.status === 403) {
              errorMessage = 'Neispravan e-mail ili lozinka!';
            }
            this.showErrorToast(errorMessage);
          }
        });
    }
  }

  private async showErrorToast(message: string) {
    const toast = await this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'bottom',
      color: 'danger'
    });
    await toast.present();
  }

  onForgotPassword() {
    this.nav.push(ForgotPasswordPage);
  }
}
